import { gql } from "@apollo/client";
import { CURRENT_MEMBER_FRAGMENT, CURRENT_PERSON_FRAGMENT } from "../fragments";

export const EVENT_DETAILS_FRAGMENT = gql`
  fragment EventDetailsFragment on MembershipEvent {
    id
    eventType
    registrationType
    title
    description
    registrationOpenAt
    registrationCloseAt
    startsAt
    endsAt
    timezone
    cancelledAt
    slug
    bannerImageUrl
    termsContent
    printablePass
    registrationFull
    hasWaitlist
    waitlistEnabled
    customFields
    facility {
      name
    }
    address1
    address2
    city
    state
    zip
    location
    locationType
    sessions {
      id
      orderKey
      startsAt
      endsAt
      title
      location
      hasAvailability
    }
  }
`;

export const ORDER_PREVIEW_FRAGMENT = gql`
  fragment OrderPreviewFragment on MembershipEvent {
    orderPreview {
      lineItemsTotal
      lineItems {
        name
        notes
        priceCents
      }
    }
  }
`;

export const OFFLINE_FEE_FRAGMENT = gql`
  fragment OfflineFeeFragment on MembershipEvent {
    offlineFee {
      name
      priceCents
    }
  }
`;

export const CURRENT_MEMBER_QUERY = gql`
  query getCurrentMember {
    currentMember {
      ...CurrentMemberFragment
    }
  }
  ${CURRENT_MEMBER_FRAGMENT}
`;

export const CURRENT_PERSON_QUERY = gql`
  query getCurrentPerson {
    currentPerson {
      ...CurrentPersonFragment
      dateOfBirth
    }
  }
  ${CURRENT_PERSON_FRAGMENT}
`;

export const CREATE_EVENT_REGISTRATION = gql`
  mutation CreateEventRegistration($input: MembershipCreateEventRegistrationInput!) {
    createEventRegistration(input: $input) {
      success
      message
    }
  }
`;

export const EVENT_REGISTRATION_QUERY = gql`
  query eventRegistrationQuery($slug: String!, $status: MembershipEventRegistrationStatusEnum) {
    eventRegistration(slug: $slug, status: $status) {
      status
      acceptedTerms
      registeredAt
      canceledAt
      event {
        title
        description
        startsAt
        endsAt
        cancelledAt
        slug
      }
      sessions {
        endsAt
        id
        location
        orderKey
        startsAt
        title
      }
    }
  }
`;

export const EVENT_ELIGIBILITY_QUERY = gql`
  query eventEligibilityQuery($slug: String!) {
    eventEligibility(slug: $slug) {
      isEligible
      eligibilityErrors
    }
  }
`;

export const EVENT_WAITLIST_ENTRY_QUERY = gql`
  query eventWaitlistEntryQuery($slug: String!) {
    eventWaitlistEntry(slug: $slug) {
      removed
      promoted
    }
  }
`;

export const CREATE_EVENT_PAYMENT_INTENT_MUTATION = gql`
  mutation CreateMembershipEventPaymentIntent($input: MembershipCreateEventPaymentIntentInput!) {
    createPaymentIntent: createMembershipEventPaymentIntent(input: $input) {
      merchantDisplayName
      paymentIntentClientSecret
      customerEphemeralKeySecret
      customerId
      customerName
      customerEmail
      total
      orderId
      stripeAccount
    }
  }
`;

export const CREATE_EVENT_WAITLIST_ENTRY_MUTATION = gql`
  mutation CreateEventWaitlistEntry($eventId: ID!) {
    createEventWaitlistEntry(eventId: $eventId) {
      success
      message
    }
  }
`;
